import React from 'react'

import {Input} from 'reakit'

import DropdownField from './DropdownField'
import ReactQuill from 'react-quill'; // ES6
import {Switch} from "@smooth-ui/core-sc";
import 'react-quill/dist/quill.snow.css'; // ES6

const adapt  = Component => ({input, meta: { valid }, ...rest}) => <Component {...input} {...rest} valid={valid} />


export const AdaptedInput = adapt(Input)
export const AdaptedSwitch = adapt(Switch)
export const AdaptedQuill = adapt(ReactQuill)

// var defaultColors = AdaptedQuill.Toolbar.defaultColors;

var modules ={
	toolbar: [
		[{ 'header': [1, 2, false] }],
		[ 'bold', 'italic', 'underline', 'strike' ],
		[{ 'color': [] }, { 'background': [] }],
		[{ 'script': 'super' }, { 'script': 'sub' }],
		['blockquote', 'code-block' ],
		[{ 'list': 'ordered' }, { 'list': 'bullet'}, { 'indent': '-1' }, { 'indent': '+1' }],
		[{ 'align': [] }, 'direction' ],
		[ 'clean' ]
	],
};

AdaptedQuill.defaultProps = {
	modules: modules,
	formats: [
		'header',
		'bold', 'italic', 'underline', 'blockquote',
		'color', 'background', 'script', 'blockquote', 'list', 'align', 'clean'
	],
	theme: 'snow'
};




export const AdaptedDropdown = ({ input, meta, ...rest }) => {
 return (
	<DropdownField
		{...input}
		//in rest there are the options
		{...rest}
		selected={[input.value]}
		handleSelect={(value, type) => input.onChange(value) }
	/>
  )
 }